import { CSSTransitionProps } from 'primereact/csstransition';
import { Dialog as PrimeDialog } from 'primereact/dialog';
import { CSSProperties, ReactNode } from 'react';
import './Dialog.css';

export interface DialogProps {
    visible: boolean;
    onHide: () => void;
    header?: ReactNode;
    children?: ReactNode;
    id?: string;
    style?: CSSProperties;
    modal?: boolean;
    dismissableMask?: boolean;
    /** Shows the header's X button. */
    closable?: boolean;
    closeOnEscape?: boolean;
    draggable?: boolean;
    'data-testid'?: string;
    /** Renders inline instead of portaling to document.body — needed to scope a CSS zoom fix to a subtree. */
    appendTo?: 'self';
    /** Fires after the close animation, once PrimeReact has returned focus to the opener. */
    onExited?: () => void;
}

export const Dialog = ({
    visible,
    onHide,
    header,
    children,
    id,
    style,
    modal = true,
    dismissableMask = true,
    closable = true,
    closeOnEscape = true,
    draggable = false,
    'data-testid': dataTestId,
    appendTo,
    onExited,
}: DialogProps) => (
    <PrimeDialog
        visible={visible}
        onHide={onHide}
        header={header}
        id={id}
        style={{ ...style }}
        modal={modal}
        dismissableMask={dismissableMask}
        closable={closable}
        closeOnEscape={closeOnEscape}
        draggable={draggable}
        data-testid={dataTestId}
        appendTo={appendTo}
        // PrimeReact spreads these over its own timeout, so a partial set is safe; its typing wants a full set.
        transitionOptions={
            onExited
                ? ({ onExited } as Partial<CSSTransitionProps> as CSSTransitionProps)
                : undefined
        }
    >
        {children}
    </PrimeDialog>
);
